<template>
  <metainfo><template v-slot:title></template></metainfo>
  <Display />
  <SettingsPanel />
  <div id="nav">
    <router-link to="/">Map</router-link> |
    <router-link to="/artaria">Artaria</router-link> |
    <router-link to="/cataris">Cataris</router-link> |
    <router-link to="/dairon">Dairon</router-link> |
    <router-link to="/burenia">Burenia</router-link> |
    <router-link to="/ferenia">Ferenia</router-link> |
    <router-link to="/ghavoran">Ghavoran</router-link> |
    <router-link to="/elun">Elun</router-link> |
    <router-link to="/hanubia">Hanubia</router-link>
  </div>
  <router-view />
  <Tracker />
</template>
<script>
import Tracker from "@/components/Tracker.vue";
import Display from "@/components/Display.vue";
import SettingsPanel from "@/components/SettingsPanel.vue";
import { useMeta } from "vue-meta";
import { useStore } from "vuex";
import { onMounted } from "vue";
export default {
  name: "app",
  components: { Tracker, Display, SettingsPanel },
  setup() {
    useMeta({
      title: "Metroid Dread Tracker",
      description:
        "This is a map tracker for metroid dread randomizer that I created for myself to test the logic to as close as I could to Randovania. This can also be used as just a item tracker for metroid dread",
      author: "KindaSneaki",
      game: "Metroid Dread",
      type: "Map Tracker",
    });
    // DAT-04 / D-02: Warm the logic engine at app init.
    // Fetches public/logic/*.json, asserts schema, builds the frozen GameModel.
    // Non-blocking — the existing hand-authored engine keeps driving the UI (D-05).
    const store = useStore();
    onMounted(() => {
      store.dispatch("logic/load");
    });
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#nav {
  padding: 50px;
  text-align: center;
  position: relative;
}

#nav a {
  font-weight: bold;
  color: #92a5b8;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
/* Collected (checkbox checked) — blue, regardless of logic state */
input[type="checkbox"]:checked + .toggle_switch {
  background: #2f80ed;
  color: #fff; /* background-image: url("checked.png"); */
}
input[type="checkbox"]:checked + .toggle_switch_noLogic {
  background: #2f80ed;
  color: #fff; /* background-image: url("checked.png"); */
}
/* In logic / available, not yet collected — green */
.toggle_switch {
  border: 1px solid #000;
  display: inline-block;
  padding: 3px;
  background: #1deb38;
  height: 10px;
  width: 10px; /* background: url("unchecked.png") no-repeat left center; */ /*
padding-left: 15px; */
}
/* Out of logic, not yet collected — gray */
.toggle_switch_noLogic {
  border: 1px solid #000;
  display: inline-block;
  padding: 3px;
  background: #888888;
  height: 10px;
  width: 10px;
}
input[type="checkbox"] {
  display: none;
}
body {
  background-color: #0b131a;
}
.toggle_box {
  position: absolute;
}
</style>
